import { Lazyload } from "vant";
import "vant/es/lazyload/style";

export default defineNuxtPlugin(nuxtApp => {
	// 配置 Vant Lazyload
	nuxtApp.vueApp.use(Lazyload, {
		loading: "/images/loading.gif", // 可选：加载中的占位图
		error: "/images/error.png", // 可选：加载失败的占位图
		attempt: 3, // 可选：尝试次数
		listenEvents: [
			"scroll",
			"wheel",
			"mousewheel",
			"resize",
			"animationend",
			"transitionend",
			"touchmove",
		],
		adapter: {
			loaded({
				bindType,
				el,
				naturalHeight,
				naturalWidth,
				$parent,
				src,
				loading,
				error,
				ImageCache,
			}) {
				// 图片加载完成后的回调
			},
			loading(listender, Init) {
				// 图片开始加载时的回调
			},
			error(listender, Init) {
				// 图片加载失败时的回调
			},
		},
	});
});
